export interface Buckets {
  data: number[][];
  minValue: number;
  maxValue: number;
}

const bucketize = (arr: number[], bucketSize: number, minValue?: number, maxValue?: number): Buckets => {
  const buckets = new Array(bucketSize);
  for (let i = 0; i < buckets.length; i++) {
    buckets[i] = [];
  }

  if (arr.length === 0) {
    return { data: buckets, minValue: 0, maxValue: 0 } as Buckets;
  }

  if (minValue === undefined || maxValue === undefined) {
    minValue = arr[0] || 0;
    maxValue = arr[0] || 0;

    // get min and max values in the input array
    arr.forEach((curValue) => {
      if (curValue < Number(minValue)) {
        minValue = curValue;
      } else if (curValue > Number(maxValue)) {
        maxValue = curValue;
      }
    });
  }

  // TODO: if we haven't assigned carbon values we may get a range of 0 then divide by 0!
  const range = maxValue - minValue;
  arr.forEach((curValue) => {
    if (range === 0) {
      buckets[0].push(curValue);
    } else {
      const index = Math.floor(((curValue - Number(minValue)) / range) * (bucketSize - 1));
      buckets[index].push(curValue);
    }
  });

  buckets.forEach((bucket) => {
    bucket.sort((a: number, b: number) => a - b);
  });

  return { data: buckets, minValue, maxValue } as Buckets;
};

export default bucketize;
